import i18n from "../../../../../../constants/i18n";
import { TReportUserDetails } from "../../../../../../Types";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import TesterBadge from "./tester-badge";
import StripeUserBadge from "./stripe-user-badge";
import UserDetails from "./user-details";
import TagBadge from "../../../../../../core/et3-shared-components/TagBadge";

const UserReportDetails = withLiteObserverAndTheme<{
  type: "REPORTER" | "REPORTED";
  isPaidVIP: boolean;
  isPaidPlus: boolean;
  isPaidAlKhattabat: boolean;
  isPaidSilver: boolean;
  isPaidGold: boolean;
  isPaidBlack: boolean;
  isPaidPlatinum: boolean;
  isPaidBoost: boolean;
  isPaidRewind: boolean;
  isPaidPower: boolean;
  isSubscribedVIP: boolean;
  isSubscribedPlus: boolean;
  isSubscribedAlkhattabat: boolean;
  isSubscribedSilver: boolean;
  isSubscribedGold: boolean;
  isSubscribedBlack: boolean;
  isSubscribedPlatinum: boolean;
  isSubscribedBoost: boolean;
  isSubscribedRewind: boolean;
  isSubscribedPower: boolean;
  isTester: boolean;
  wasStripeUser: boolean;
  user: TReportUserDetails;
}>((props) => {
  const {
    type,
    wasStripeUser,
    isPaidVIP,
    isPaidPlus,
    isPaidAlKhattabat,
    isPaidSilver,
    isPaidGold,
    isPaidBlack,
    isPaidPlatinum,
    isPaidBoost,
    isPaidRewind,
    isPaidPower,
    isSubscribedVIP,
    isSubscribedPlus,
    isSubscribedAlkhattabat,
    isSubscribedSilver,
    isSubscribedGold,
    isSubscribedBlack,
    isSubscribedPlatinum,
    isSubscribedBoost,
    isSubscribedRewind,
    isSubscribedPower,
    isTester,
    user,
    theme
  } = props;
  const { colors } = theme;

  const badgeRows = [
    [
      {
        tag: i18n.get("SILVER_TAG"),
        color: isSubscribedSilver ? colors.all.plumBrown : colors.all.gray,
        isPaid: isPaidSilver,
        width: 100
      },
      {
        tag: i18n.get("GOLD_TAG"),
        color: isSubscribedGold ? colors.all.bronzedGold : colors.all.gray,
        isPaid: isPaidGold,
        width: 100
      },
      {
        tag: i18n.get("PLATINUM_TAG"),
        color: isSubscribedPlatinum
          ? colors.all.mutedSteelBlue
          : colors.all.gray,
        isPaid: isPaidPlatinum,
        width: 120
      },
      {
        tag: i18n.get("BLACK_TAG"),
        color: isSubscribedBlack ? colors.all.black : colors.all.gray,
        isPaid: isPaidBlack,
        width: 100
      }
    ],
    [
      {
        tag: i18n.get("VIP"),
        color: isSubscribedVIP ? colors.all.vipGold : colors.all.gray,
        isPaid: isPaidVIP,
        width: 100
      },
      {
        tag: i18n.get("PLUS"),
        color: isSubscribedPlus ? colors.all.purple : colors.all.gray,
        isPaid: isPaidPlus,
        width: 100
      },
      {
        tag: i18n.get("KHATTABAT_TAG"),
        color: isSubscribedAlkhattabat
          ? colors.all.brightCyan
          : colors.all.gray,
        isPaid: isPaidAlKhattabat,
        width: 120
      }
    ],
    [
      {
        tag: i18n.get("BOOST"),
        color: isSubscribedBoost ? colors.all.vipGold : colors.all.gray,
        isPaid: isPaidBoost,
        width: 100
      },
      {
        tag: i18n.get("REWIND"),
        color: isSubscribedRewind ? colors.all.purple : colors.all.gray,
        isPaid: isPaidRewind,
        width: 100
      },
      {
        tag: i18n.get("BUNDLE"),
        color: isSubscribedPower ? colors.all.powerPurple : colors.all.gray,
        isPaid: isPaidPower,
        width: 120
      }
    ]
  ];

  return (
    <ET3Div
      isScrollable={false}
      width={650}
      height={620}
      color={colors.all.transparent}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        width={650}
        height={180}
        color={colors.all.transparent}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        style={{
          fontSize: 16
        }}
        onClick={() => {}}
      >
        {i18n.get(type)}
        <ET3Div
          isScrollable={false}
          width={460}
          height={160}
          color={colors.all.transparent}
          isExtendable={false}
          fDirection="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          withShadow={false}
          style={{
            gap: "6px",
            marginLeft: "15px"
          }}
          onClick={() => {}}
        >
          {badgeRows.map((row, rowIndex) => (
            <ET3Div
              key={rowIndex}
              isScrollable={false}
              width={460}
              height={36}
              color={colors.all.transparent}
              isExtendable={false}
              fDirection="row"
              justifyContent="flex-start"
              alignItems="center"
              withShadow={false}
              style={{ gap: "10px", width: "100%" }}
              onClick={() => {}}
            >
              {row.map((badge, idx) => (
                <TagBadge
                  key={`${rowIndex}-${idx}`}
                  tag={badge.tag}
                  tagColor={badge.color}
                  tagWidth={badge.width}
                  isPaid={badge.isPaid}
                />
              ))}
            </ET3Div>
          ))}
          <ET3Div
            isScrollable={false}
            width={460}
            height={36}
            color={colors.all.transparent}
            isExtendable={false}
            fDirection="row"
            justifyContent="flex-start"
            alignItems="center"
            withShadow={false}
            style={{ width: "100%" }}
            onClick={() => {}}
          >
            <TesterBadge
              isTester={isTester}
              style={{
                alignSelf: "unset",
                height: 32,
                minHeight: 32,
                width: "unset",
                minWidth: "unset"
              }}
            />
            <Et3Margin top={0} bottom={0} left={10} right={0} />
            <StripeUserBadge wasStripeUser={wasStripeUser} />
          </ET3Div>
        </ET3Div>
      </ET3Div>
      <Et3Margin top={10} bottom={0} right={0} left={0} />
      <UserDetails user={user} />
    </ET3Div>
  );
});

export default UserReportDetails;
